(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bb-buy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bb-product-quantity')) {
  customElements.define('bb-product-quantity', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      const input = this.querySelector('input');
      const minus = this.querySelector('[data-quantity-minus]');
      const plus = this.querySelector('[data-quantity-plus]');
      const sync = () => {
        minus.disabled = input.valueAsNumber <= Number(input.min || 1);
        plus.disabled = input.max !== '' && input.valueAsNumber >= Number(input.max);
      };
      const changeQuantity = direction => {
        if (!Number.isFinite(input.valueAsNumber)) input.value = input.min || '1';
        else if (direction > 0) input.stepUp();
        else input.stepDown();
        sync();
        input.dispatchEvent(new Event('input', {bubbles: true}));
        input.dispatchEvent(new Event('change', {bubbles: true}));
      };
      minus.hidden = false;
      plus.hidden = false;
      sync();
      minus.addEventListener('click', () => changeQuantity(-1), options);
      plus.addEventListener('click', () => changeQuantity(1), options);
      input.addEventListener('input', sync, options);
      input.addEventListener('change', sync, options);
      this.rulesObserver = new MutationObserver(sync);
      this.rulesObserver.observe(input, {attributes: true, attributeFilter: ['min', 'max', 'step']});
    }
    disconnectedCallback() {
      this.events?.abort();
      this.rulesObserver?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bb-country"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    document.querySelectorAll('.bb-country-picker[open]').forEach((picker) => {
      if (!picker.contains(event.target)) picker.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.bb-country-picker[open]').forEach((picker) => {
      picker.open = false;
      if (picker.contains(document.activeElement)) picker.querySelector('summary').focus();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
